import axios from 'axios';
import { isMobile } from './nuiDeviceDetector';
import {updateParentCookies, getCookieBoolean} from './nuiCookieLib';

export function isFrameInSite() {
  return window.self !== window.top;
}

export function sendHeartBeatNotification(iFrameName) {
  setInterval(() => {
    window.parent.postMessage(
      {message: 'heartBeat',
       childFrame: {name: iFrameName}}, "*");
  }, 2000);
}

export function sendResizeNotification(iFrameName,
                                       height) {
  if (window.parent != null) {
    // height from resizeObserver or document.body.scrollHeight
    window.parent.postMessage(
      {message: 'resize',
       childFrame: {name: iFrameName,
                    height: (height + (isMobile() ? 60 : 20))}}, "*");
  }
}

/** params:
  * - iFrameName
  * - self
  * - stateFromCookesBoolean
  */
export function addMessageListener(params) {
  window.addEventListener('message', event => {
    // IMPORTANT: check the origin of the data!
    if (event.origin === 'https://es.robotaxmaker.com' ||
        event.origin === 'https://finparser.com') {
      if (event.data.message === 'serverRequest') {
        serverRequest(event.data);
      }
      if (event.data.cookiechange) {
        updateParentCookies(event.data.cookiechange);
        if (params.stateFromCookesBoolean != undefined) {
          params.stateFromCookesBoolean.forEach(sfc => {
            if (params.self.state[sfc.name] != getCookieBoolean(sfc.name, sfc.default)) {
              params.self.setState({[sfc.name]: getCookieBoolean(sfc.name, sfc.default)});
            }
          });
        }
      }
      if (params.dialogHandlers != undefined &&
          event.data.dialogResponse != undefined) {
        const dHandler = params.dialogHandlers.find(dh =>
          dh.dialogName === event.data.dialogResponse.dialogName);
        if (dHandler != undefined && dHandler.handler != undefined) {
          dHandler.handler(event.data.dialogResponse.response);
        }
      }
      sendResizeNotification(
        params.iFrameName,
        document.body.scrollHeight);
    } else {
      // The data was NOT sent from your site!
      // Be careful! Do not use it. This else branch is
      // here just for clarity, you usually shouldn't need it.
      return;
    }
  });
}

function messageResponse(status, data, params) {
  window.parent.postMessage(
    {message: 'serverResponse',
     response: {
       name: params.request.name,
       status: status,
       data: data
     }}, "*");
}

export function serverRequest(params) {
  axios({
    method: params.request.method,
    url: params.request.url,
    headers: {'X-Requested-With': 'HttpRequest',
              'Csrf-Token': 'nocheck'}})
    .then((response) => messageResponse(response.status, response.data, params))
    .catch((error) => messageResponse(error.status, error.data, params));
}
